<template>
    <div id="home_center_base">
        <div>
            <div id="banner_container" class="banner_container">
                <ul id="banner_ul" class="banner_ul">
                    <li v-for="(item, index) in datalist" v-bind:key="index" :class="'banner_li banner' + item.sn"
                        :num_order="item.sn" :style="'opacity:' + item.opacity">
                        <div class="banner_txt">{{ item.txt }}</div>
                    </li>
                </ul>
                <div class="banner_num_container">
                    <div v-for="(item, index) in datalist" v-bind:key="item"
                        :class="'banner_num_one ' + (item.isOn ? 'banner_selected' : '')" :num_order="item.sn"
                        @mouseenter="mouseEnter(index)" @mouseleave="mouseLeave(index)" @click="changeImg(index)">
                        {{ item.sn }}
                    </div>
                </div>
            </div>
        </div>
        <div id="banner_list_div1">
            <div id="banner_list_div2">
                <News1></News1>
                <History1></History1>
            </div>
        </div>
    </div>
</template>

<script>
import News1 from '../components/News1.vue'
import History1 from '../components/History1.vue'
export default {
    name: 'index',
    components: { News1, History1 },
    data() {
        return {
            datalist: [{ sn: '1', isOn: true, opacity: 1, txt: '写点什么呢，算了不写了！！！' },
            { sn: '2', isOn: false, opacity: 0, txt: '' },
            { sn: '3', isOn: false, opacity: 0, txt: '' }],
            selIndex: 0,
            timmer: null,
            isMouseOn: false,
            nowRunID: ''// 当前允许显示隐藏的定时器编号
        }
    },
    methods: {
        mouseEnter: function(ind) {
            this.isMouseOn = true;
            this.changeImg(ind);
        },
        mouseLeave: function(ind) {
            this.isMouseOn = false;
        },
        hideAndShow: function(rid, ind, type) {
            var self = this;
            var time1 = setInterval(function () {
                if (rid == self.nowRunID) {
                    var opacity = self.datalist[ind].opacity;
                    if (type == 'show') {
                        opacity = opacity + 0.05;
                        if (opacity >= 1) {
                            clearInterval(time1);
                        } else {
                            self.datalist[ind].opacity = opacity;
                        }
                    } else if (type == 'hide') {
                        opacity = opacity - 0.05;
                        if (opacity <= 0) {
                            clearInterval(time1);
                        } else {
                            self.datalist[ind].opacity = opacity;
                        }
                    }
                }
            }, 50);
            setTimeout(() => {
                clearInterval(time1);
                if (rid == self.nowRunID) {
                    if (type == 'show') {
                        self.datalist[ind].opacity = 1;
                    } else if (type == 'hide') {
                        self.datalist[ind].opacity = 0;
                    }
                }
            }, 1000);
        },
        changeImg: function(ind) {
            this.selIndex = ind;
            this.nowRunID = Math.round(Math.random() * 10000);
            for (var i = 0; i < this.datalist.length; i++) {
                if (i == ind) {
                    this.datalist[i].isOn = true;
                    // this.datalist[i].opacity = 1;
                    this.hideAndShow(this.nowRunID, i, 'show')
                } else {
                    this.datalist[i].isOn = false;
                    // this.datalist[i].opacity = 0;
                    this.hideAndShow(this.nowRunID, i, 'hide')
                }
            }
        },
        autoChange: function () {
            if (this.isMouseOn) {
                return;
            }
            var now = this.selIndex;
            if (now < this.datalist.length - 1) {
                now = now + 1;
            } else {
                now = 0;
            }
            this.changeImg(now);
        }
    },
    mounted: function () {
        this.timmer = setInterval(this.autoChange, 3000);
    }
}
</script>



// WEBPACK FOOTER //
// src/html/index.vue